export default __webpack_public_path__ + "static/media/bg.431211e1.png";